import { useState } from 'react';

import { SpendingLimitTable } from './components/SpendingLimitTable/SpendingLimitTable';
import { useGetSellerSpendingLimitRequest } from './hooks/useGetSellerSpendingLimitRequest.hook';
import styles from './SpendingLimitRequests.module.css';
import { SellerNavBar } from '../../components/NavBars/SellerNavBar/SellerNavBar';
import { PageTemplate } from '../../components/PageTemplate/PageTemplate';
import { Pagination } from '../Payments/components/Pagination/Pagination';

export const SpendingLimitRequests = () => {
  const [page, setPage] = useState(1);

  const { spendingLimitRequests, isLoading, paginationLinks } =
    useGetSellerSpendingLimitRequest({ page });

  if (isLoading) return null;

  return (
    <PageTemplate NavBar={() => <SellerNavBar />}>
      <div className={styles.page}>
        <div className={styles.content}>
          <div className={styles.pageHeader}>Spending Limits</div>
          <div className={styles.paymentsActions}></div>
          <SpendingLimitTable spendingLimitRequests={spendingLimitRequests} />
        </div>
        <Pagination
          currentPageNumber={page}
          onPageSelect={(page?: number) => {
            if (!page) return;

            setPage(page);
          }}
          paginationLinks={paginationLinks}
        />
      </div>
    </PageTemplate>
  );
};
